module.exports = __webpack_public_path__ + "static/img/promote_withdrawals_bg.280362c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/promotion/promote_withdrawals_bg.png
// module id = eXBk
// module chunks = 0